module.exports = __webpack_public_path__ + "img/emoji/thinkingeyes.2baff061bf98edda3c229ec7d64db755.png";